/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Disabled_ExplainerInputs */



/**
* | output |
* | --- |
* | "Billing disabled — monthly reports keep accumulating, no invoices are created." |
*
* @param {Partner_Admin_Billing_Disabled_ExplainerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_disabled_explainer = /** @type {((inputs?: Partner_Admin_Billing_Disabled_ExplainerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Disabled_ExplainerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung deaktiviert — die Monatsberichte laufen weiter auf, es werden keine Rechnungen erstellt.")
	return /** @type {LocalizedString} */ ("Billing disabled — monthly reports keep accumulating, no invoices are created.")
});